"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error("Global Error:", error);
  }, [error]);

  return (
    <html lang="zh-CN">
      <body style={{ padding: "2rem", fontFamily: "monospace" }}>
        <h2 style={{ color: "#dc2626", marginBottom: "1rem" }}>全局错误</h2>
        <p style={{ marginBottom: "0.5rem" }}>
          <strong>Message:</strong> {error?.message || "unknown"}
        </p>
        <p style={{ marginBottom: "0.5rem" }}>
          <strong>Digest:</strong> {error?.digest || "none"}
        </p>
        <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.85rem", color: "#666" }}>
          {error?.stack || "no stack"}
        </pre>
        <a href="/" style={{ display: "inline-block", marginTop: "1rem", color: "#2563eb" }}>
          返回首页
        </a>
      </body>
    </html>
  );
}